export default __webpack_public_path__ + "357b65bd3e5ff86e30852498d79206d4.png";